module.exports = __webpack_public_path__ + "img/app-phone-1.d5c0a16.svg";